import React, { Component } from "react";
import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
class MapContainer extends Component {
  render() {
    return (
      <div style={{ position: "relative" }}>
        <Map
          google={this.props.google}
          zoom={this.props.zoom}
          style={mapStyles}
          initialCenter={{ lat: this.props.lat, lng: this.props.lng }}
        >
          <Marker position={{ lat: this.props.lat, lng: this.props.lng }} />
        </Map>
      </div>
    );
  }
}
export default GoogleApiWrapper({
  apiKey: "AIzaSyATJoiqVR4QCd3-0tZ8VkPb8WD9FJl5g34"
})(MapContainer);

const mapStyles = {
  width: "auto",
  height: "300px"
};
